<div class="flex items-center justify-center dialog-header">
  {{ type }} WhatsApp Configuration
  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>

<div class="dialog-content">
  <form [formGroup]="whatsappForm" (ngSubmit)="submitForm()" class="p-fluid grid grid-cols-2 gap-6">
    <div *ngFor="let field of ['source', 'app_name', 'api_key', 'template_id', 'email', 'password', 'app_token', 'app_id']" class="flex flex-col">
      <label class="mb-2 font-semibold">{{ field.replace('_', ' ') | titlecase }} *</label>
      <input pInputText [formControlName]="field"
             [type]="field === 'password' ? 'password' : 'text'"
             class="w-full border rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
      <div *ngIf="whatsappForm.get(field)?.invalid && (whatsappForm.get(field)?.touched || submitted)"
           class="text-red-500 text-xs mt-1">
        {{ field.replace('_', ' ') }} is required.
      </div>
    </div>

    <div class="flex flex-col">
      <label class="mb-2 font-semibold">Status *</label>
      <p-select [options]="statusOptions" formControlName="status" placeholder="Select status" class="w-full"></p-select>
    </div>

    <div class="col-span-2 flex justify-end mt-2">
      <p-button label="Submit" type="submit" [loading]="isLoading" icon="pi pi-check" class="w-full"
                [disabled]="whatsappForm.invalid || isLoading"></p-button>
    </div>
  </form>
</div>
